module.exports = __webpack_public_path__ + "static/media/The-Inextricable-Link-Between-EX-And-CX.ed22209c.jpeg";